// The scrollable message list (F-AGENT PR-B). Renders the chat turns
// oldest-first; the empty state is owned by `AgentPane` (this component is
// only mounted once there is at least one message). Pure presentation.
//
// §9 — logical RTL utilities only; per-bubble direction lives in
//      `MessageBubble` via `bidiProps`.

import { MessageBubble } from './MessageBubble'
import type { ChatMessage } from '@/domain/agent/entity'

interface MessageListProps {
  messages: ChatMessage[]
}

export function MessageList({ messages }: MessageListProps): JSX.Element {
  return (
    <div
      data-testid="agent-message-list"
      className="flex flex-1 flex-col gap-3.5 overflow-y-auto px-3.5 py-3"
    >
      {messages.map((m) => (
        <MessageBubble key={m.id} message={m} />
      ))}
    </div>
  )
}
